import { Button, Classes, ControlGroup, MenuItem, Position } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ButtonText = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const StyledButton = styled(Button)`
  justify-content: space-between;
  .bp5-button-text {
    overflow: hidden;
  }
`;

const NumberOfGenerationsSelect = ({
  className,
  disabled,
  fill,
  onChange,
  values,
  selectedValue,
  mask,
}) => {
  const renderOption = (value, { handleClick, modifiers }) => {
    const formattedValue = mask(value);
    return (
      <MenuItem
        active={modifiers.active}
        disabled={modifiers.disabled}
        key={formattedValue}
        onClick={handleClick}
        text={formattedValue}
      />
    );
  };

  return (
    <ControlGroup className={className} fill={fill}>
      <Select
        activeItem={selectedValue}
        disabled={disabled}
        filterable={false}
        className={fill ? Classes.FILL : undefined}
        itemRenderer={renderOption}
        items={values}
        noResults={<MenuItem disabled text="No results." />}
        onItemSelect={onChange}
        popoverProps={{ minimal: false, position: Position.BOTTOM_LEFT, targetTagName: 'div' }}
      >
        <StyledButton
          disabled={disabled}
          fill={fill}
          rightIcon="caret-down"
          text={
            <ButtonText>
              {selectedValue ? mask(selectedValue) : 'Select the Number of Generations'}
            </ButtonText>
          }
        />
      </Select>
    </ControlGroup>
  );
};

NumberOfGenerationsSelect.defaultProps = {
  className: undefined,
  disabled: false,
  fill: false,
  onChange: () => {},
  values: [],
  selectedValue: undefined,
  mask: value => value,
};

NumberOfGenerationsSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fill: PropTypes.bool,
  onChange: PropTypes.func,
  values: PropTypes.array,
  selectedValue: PropTypes.any,
  mask: PropTypes.func,
};

export default NumberOfGenerationsSelect;
